
<template>
  <div class="camoodoo-title-section">
    <q-img class="image" src="images\page_title.jpg"></q-img>
    <q-img class="logo" src="images\website_logo.svg"></q-img>
    <div class="purchase">
      <a
        href="https://play.google.com/store/apps/details?id=de.conpho.camote&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
      >
        <img
          class="google-play"
          alt="Get it on Google Play"
          src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.camoodoo-title-section {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-items: center;
  position: relative;
}
.image {
  align-self: stretch;
  justify-self: stretch;
  background-position-x: center;
  background-position-y: bottom;
  background-size: cover;
}
.logo {
  position: absolute;
  width: 40%;
  bottom: 20pt;
  left: 40pt;
}
.purchase {
  position: absolute;
  bottom: 20pt;
  right: 40pt;
}
.google-play {
  width: 150pt;
}
</style>
